// extracted by mini-css-extract-plugin
export default {"login":"ProfileForm_login__rbbsv","text":"ProfileForm_text__-QW5O"};